import { AttensiParam, AttensiConfig } from '@attensi/core'
import { createEntry, parseHref } from '@attensi/entry'

const entry = createEntry()

export const companyCode = parseHref(location.href).firstElementFromPath

export const config: AttensiConfig = {
  [AttensiParam.API_TOKEN]: '9a499c250f280a8f39a3e7fb79798d0a6c5eb8e8cd95d67e4d2800d3caeeee14',
  [AttensiParam.COMPANY_NAME_KEY]: entry.getCompanyNameKey(),
  [AttensiParam.LOCALE]: entry.getLocale(),
  [AttensiParam.SUBDOMAIN]: entry.getSubdomain({ path: false, query: true, localStorage: false, sessionStorage: false })
}
